/* eslint-disable */
export const faqCategories = [
    {
        id: '28924eab-97cc-465a-ba21-f232bb95843f',
        slug: 'most-asked',
        title: 'Most asked',
    },
    {
        id: '395b0d41-b9a8-4cd6-8b5c-f07855e82d62',
        slug: 'general-inquiries',
        title: 'General inquiries',
    },
    {
        id: 'b388a87f-bfbb-44d0-800c-0ddbce2a5d22',
        slug: 'licenses',
        title: 'Licenses',
    },
    {
        id: '71c34043-d89d-4aca-951d-8606c3943c43',
        slug: 'payments',
        title: 'Payments',
    },
    {
        id: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
        slug: 'support',
        title: 'Support',
    },
];
export const faqs = [
    // Most asked
    {
        id: 'f65d517a-6f69-4c88-81f5-416f47405ce1',
        categoryId: '28924eab-97cc-465a-ba21-f232bb95843f',
        question: 'Is there a 14-days trial?',
        answer: 'Magna consectetur culpa duis ad est tempor pariatur velit ullamco aute exercitation magna sunt commodo minim enim aliquip eiusmod ipsum adipisicing magna ipsum reprehenderit lorem magna voluptate magna aliqua culpa.\n\nSit nisi adipisicing pariatur enim enim sunt officia ad labore voluptate magna proident velit excepteur pariatur cillum sit excepteur elit veniam excepteur minim nisi cupidatat proident dolore irure veniam mollit.',
    },
    {
        id: '0fcece82-1691-4b98-a9b9-b63218f9deef',
        categoryId: '28924eab-97cc-465a-ba21-f232bb95843f',
        question: 'What’s the benefits of the Premium Membership?',
        answer: 'Et in lorem qui ipsum deserunt duis exercitation lorem elit qui qui ipsum tempor nulla velit aliquip enim consequat incididunt pariatur duis excepteur elit irure nulla ipsum dolor dolore est.\n\nAute deserunt nostrud id non ipsum do adipisicing laboris in minim officia magna elit minim mollit elit velit veniam lorem pariatur veniam sit excepteur irure commodo excepteur duis quis in.',
    },
    {
        id: '2e6971cd-49d5-49f1-8cbd-fba5c71e6062',
        categoryId: '28924eab-97cc-465a-ba21-f232bb95843f',
        question: 'How much time I will need to learn this app?',
        answer: 'Id fugiat et cupidatat magna nulla nulla eu cillum officia nostrud dolore in veniam ullamco nulla ex duis est enim nisi aute ipsum velit et laboris est pariatur est culpa.\n\nCulpa sunt ipsum esse quis excepteur enim culpa est voluptate reprehenderit consequat duis officia irure voluptate veniam dolore fugiat dolor est amet nostrud non velit irure do voluptate id sit.',
    },
    {
        id: '974f93b8-336f-4eec-b011-9ddb412ee828',
        categoryId: '28924eab-97cc-465a-ba21-f232bb95843f',
        question: 'Are there any free tutorials available?',
        answer: 'Excepteur deserunt tempor do lorem elit id magna pariatur irure ullamco elit dolor consectetur ad officia fugiat incididunt do elit aute esse eu voluptate adipisicing incididunt ea dolor aliqua dolor.\n\nConsequat est quis deserunt voluptate ipsum incididunt laboris occaecat irure laborum voluptate non sit labore voluptate sunt id sint ut laboris aute cupidatat occaecat eiusmod non magna aliquip deserunt nisi.',
    },
    {
        id: '5d877fc7-b881-4527-a6aa-d39d642feb23',
        categoryId: '28924eab-97cc-465a-ba21-f232bb95843f',
        question: 'Is there a month-to-month payment option?',
        answer: 'Labore mollit in aliqua exercitation aliquip elit nisi nisi voluptate reprehenderit et dolor incididunt cupidatat ullamco nulla consequat voluptate adipisicing dolor qui magna sint aute do excepteur in aliqua consectetur.\n\nElit laborum non duis irure ad ullamco aliqua enim exercitation quis fugiat aute esse esse magna et ad cupidatat voluptate sint nulla nulla lorem et enim deserunt proident deserunt consectetur.',
    },
    // General inquiries
    {
        id: '3d1c26c5-1e5e-4eb6-8006-ed6037ed9aca',
        categoryId: '395b0d41-b9a8-4cd6-8b5c-f07855e82d62',
        question: 'How to download your items',
        answer: 'Sunt mollit irure dolor aliquip sit veniam amet ut sunt dolore cillum sint pariatur qui irure proident velit non excepteur quis ut et quis velit aliqua ea sunt cillum sit.\n\nReprehenderit est culpa ut incididunt sit dolore mollit in occaecat velit culpa consequat reprehenderit ex lorem cupidatat proident reprehenderit ad eu sunt sit ut sit culpa ea reprehenderit aliquip est.',
    },
    {
        id: '11bd2b9a-85b4-41c9-832c-bd600dfa3a52',
        categoryId: '395b0d41-b9a8-4cd6-8b5c-f07855e82d62',
        question: 'View and download invoices',
        answer: 'Sint mollit consectetur voluptate fugiat sunt ipsum adipisicing labore exercitation eiusmod enim excepteur enim proident velit sint magna commodo dolor ex ipsum sit nisi deserunt labore eu irure amet ea.\n\nOccaecat ut velit et sint pariatur laboris voluptate duis aliqua aliqua exercitation et duis duis eu laboris excepteur occaecat quis esse enim ex dolore commodo fugiat excepteur adipisicing in fugiat.',
    },
    {
        id: 'f55c023a-785e-4f0f-b5b7-47da75224deb',
        categoryId: '395b0d41-b9a8-4cd6-8b5c-f07855e82d62',
        question: 'I\'ve forgotten my username or password',
        answer: 'In exercitation sunt ad anim commodo sunt do in sunt est officia amet ex ullamco do nisi consectetur lorem proident lorem adipisicing incididunt consequat fugiat voluptate sint est anim officia.\n\nVelit sint aliquip elit culpa amet eu mollit veniam esse deserunt ex occaecat quis lorem minim occaecat culpa esse veniam enim duis excepteur ipsum esse ut ut velit cillum adipisicing.',
    },
    {
        id: 'c577a67d-357a-4b88-96e8-a0ee1fe9162e',
        categoryId: '395b0d41-b9a8-4cd6-8b5c-f07855e82d62',
        question: 'Where is my license code?',
        answer: 'Ad adipisicing duis consequat magna sunt consequat aliqua eiusmod qui et nostrud voluptate sit enim reprehenderit anim exercitation ipsum ipsum anim ipsum laboris aliqua ex lorem aute officia voluptate culpa.\n\nNostrud anim ex pariatur ipsum et nostrud esse veniam ipsum ipsum irure velit ad quis irure tempor nulla amet aute id esse reprehenderit ea consequat consequat ea minim magna magna.',
    },
    {
        id: '1a680c29-7ece-4a80-9709-277ad4da8b4b',
        categoryId: '395b0d41-b9a8-4cd6-8b5c-f07855e82d62',
        question: 'How to contact an author',
        answer: 'Magna laborum et amet magna fugiat officia deserunt in exercitation aliquip nulla magna velit ea labore quis deserunt ipsum occaecat id id consequat non eiusmod mollit est voluptate ea ex.\n\nReprehenderit mollit ut excepteur minim veniam fugiat enim id pariatur amet elit nostrud occaecat pariatur et esse aliquip irure quis officia reprehenderit voluptate voluptate est et voluptate sint esse dolor.',
    },
    {
        id: 'c49c2216-8bdb-4df0-be25-d5ea1dbb5688',
        categoryId: '395b0d41-b9a8-4cd6-8b5c-f07855e82d62',
        question: 'How does the affiliate program work?',
        answer: 'Adipisicing laboris ipsum fugiat et cupidatat aute esse ad labore et est cillum ipsum sunt duis do veniam minim officia deserunt in eiusmod eu duis dolore excepteur consectetur id elit.\n\nAnim excepteur occaecat laborum sunt in elit quis sit duis adipisicing laboris anim laborum et pariatur elit qui consectetur laborum reprehenderit occaecat nostrud pariatur aliqua elit nisi commodo eu excepteur.',
    },
    // Licenses
    {
        id: '3ef176fa-6cba-4536-9f43-540c686a4faa',
        categoryId: 'b388a87f-bfbb-44d0-800c-0ddbce2a5d22',
        question: 'How do licenses work for items I bought?',
        answer: 'Culpa duis nostrud qui velit sint magna officia fugiat ipsum eiusmod enim laborum pariatur anim culpa elit ipsum lorem pariatur exercitation laborum do labore cillum exercitation nisi reprehenderit exercitation quis.\n\nMollit aute dolor non elit et incididunt eiusmod non in commodo occaecat id in excepteur aliqua ea anim pariatur sint elit voluptate dolor eu non laborum laboris voluptate qui duis.',
    },
    {
        id: '7bc6b7b4-7ad8-4cbe-af36-7301642d35fb',
        categoryId: 'b388a87f-bfbb-44d0-800c-0ddbce2a5d22',
        question: 'Do licenses have an expiry date?',
        answer: 'Ea proident dolor tempor dolore incididunt velit incididunt ullamco quis proident consectetur magna excepteur cillum officia ex do aliqua reprehenderit est esse officia labore dolore aute laboris eu commodo aute.\n\nOfficia quis id ipsum adipisicing ipsum eu exercitation cillum ex elit pariatur adipisicing ullamco ullamco nulla dolore magna aliqua reprehenderit eu laborum voluptate reprehenderit non eiusmod deserunt velit magna do.',
    },
    {
        id: '56c9ed66-a1d2-4803-a160-fba29b826cb4',
        categoryId: 'b388a87f-bfbb-44d0-800c-0ddbce2a5d22',
        question: 'I want to make multiple end products with the same item',
        answer: 'Elit cillum incididunt enim cupidatat ex elit cillum aute dolor consectetur proident non minim eu est deserunt proident mollit ullamco laborum anim ea labore anim ex enim ullamco consectetur enim.\n\nEx magna consectetur esse enim consequat non aliqua nulla labore mollit sit quis ex fugiat commodo eu cupidatat irure incididunt consequat enim ut deserunt consequat elit consequat sint adipisicing sunt.',
    },
    {
        id: '21c1b662-33c8-44d7-9530-91896afeeac7',
        categoryId: 'b388a87f-bfbb-44d0-800c-0ddbce2a5d22',
        question: 'How easy is it to change the license type?',
        answer: 'Duis culpa ut veniam voluptate consequat proident magna eiusmod id est magna culpa nulla enim culpa mollit velit lorem mollit ut minim dolore in tempor reprehenderit cillum occaecat proident ea.\n\nVeniam fugiat ea duis qui et eu eiusmod voluptate id cillum eiusmod eu reprehenderit minim reprehenderit nisi cillum nostrud duis eu magna minim sunt voluptate eu pariatur nulla ullamco elit.',
    },
    {
        id: '5fa52c90-82be-41ae-96ec-5fc67cf054a4',
        categoryId: 'b388a87f-bfbb-44d0-800c-0ddbce2a5d22',
        question: 'Do I need a Regular License or an Extended License?',
        answer: 'Mollit nostrud ea irure ex ipsum in cupidatat irure sit officia reprehenderit adipisicing et occaecat cupidatat exercitation mollit esse in excepteur qui elit exercitation velit fugiat exercitation est officia excepteur.\n\nQuis esse voluptate laborum non veniam duis est fugiat tempor culpa minim velit minim ut duis qui officia consectetur ex nostrud ut elit elit nulla in consectetur voluptate aliqua aliqua.',
    },
    // Payments
    {
        id: '81ac908c-35a2-4705-8d75-539863c35c09',
        categoryId: '71c34043-d89d-4aca-951d-8606c3943c43',
        question: 'Common PayPal, Skrill, and credit card issues',
        answer: 'Sit occaecat sint nulla in esse dolor occaecat in ea sit irure magna magna veniam fugiat consequat exercitation ipsum ex officia velit consectetur consequat voluptate lorem eu proident lorem incididunt.\n\nExcepteur exercitation et qui labore nisi eu voluptate ipsum deserunt deserunt eu est minim dolor ad proident nulla reprehenderit culpa minim voluptate dolor nostrud dolor anim labore aliqua officia nostrud.',
    },
    {
        id: 'b6d8909f-f36d-4885-8848-46b8230d4476',
        categoryId: '71c34043-d89d-4aca-951d-8606c3943c43',
        question: 'How do I find my transaction ID?',
        answer: 'Laboris ea nisi commodo nulla cillum consequat consectetur nisi velit adipisicing minim nulla culpa amet quis sit duis id id aliqua aute exercitation non reprehenderit aliquip enim eiusmod eu irure.\n\nNon irure consectetur sunt cillum do adipisicing excepteur labore proident ut officia dolor fugiat velit sint consectetur cillum qui amet enim anim mollit laboris consectetur non do laboris lorem aliqua.',
    },
    {
        id: '9496235d-4d0c-430b-817e-1cba96404f95',
        categoryId: '71c34043-d89d-4aca-951d-8606c3943c43',
        question: 'PayPal disputes And chargebacks',
        answer: 'Ullamco eiusmod do pariatur pariatur consectetur commodo proident ex voluptate ullamco culpa commodo deserunt pariatur incididunt nisi magna dolor est minim eu ex voluptate deserunt labore id magna excepteur et.\n\nReprehenderit dolore pariatur exercitation ad non fugiat quis proident fugiat incididunt ea magna pariatur et exercitation tempor cillum eu consequat adipisicing est laborum sit cillum ea fugiat mollit cupidatat est.',
    },
    {
        id: '7fde17e6-4ac1-47dd-a363-2f4f14dcf76a',
        categoryId: '71c34043-d89d-4aca-951d-8606c3943c43',
        question: 'Saving your credit card details',
        answer: 'Qui quis nulla excepteur voluptate elit culpa occaecat id ex do adipisicing est mollit id anim nisi irure amet officia ut sint aliquip dolore labore cupidatat magna laborum esse ea.\n\nEnim magna duis sit incididunt amet anim et nostrud laborum eiusmod et ea fugiat aliquip velit sit fugiat consectetur ipsum anim do enim excepteur cupidatat consequat sunt irure tempor ut.',
    },
    {
        id: '90a3ed58-e13b-40cf-9219-f933bf9c9b8f',
        categoryId: '71c34043-d89d-4aca-951d-8606c3943c43',
        question: 'Why do prepaid credits expire?',
        answer: 'Consequat consectetur commodo deserunt sunt aliquip deserunt ex tempor esse nostrud sit dolore anim nostrud nulla dolore veniam minim laboris non dolor veniam lorem veniam deserunt laborum aute amet irure.\n\nEiusmod officia veniam reprehenderit ea aliquip velit anim aute minim aute nisi tempor qui sunt deserunt voluptate velit elit ut adipisicing ipsum et excepteur ipsum eu ullamco nisi esse dolor.',
    },
    {
        id: '153376ed-691f-4dfd-ae99-e204a49edc44',
        categoryId: '71c34043-d89d-4aca-951d-8606c3943c43',
        question: 'Why is there a minimum $20 credit?',
        answer: 'Duis sint velit incididunt exercitation eiusmod nisi sunt ex est fugiat ad cupidatat sunt nisi elit do duis amet voluptate ipsum aliquip lorem aliqua sint esse in magna irure officia.\n\nNon eu ex elit ut est voluptate tempor amet ut officia in duis deserunt cillum labore do culpa id dolore magna anim consectetur qui consectetur fugiat labore mollit magna irure.',
    },
    // Support
    {
        id: '4e7ce72f-863a-451f-9160-cbd4fbbc4c3d',
        categoryId: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
        question: 'What is item support?',
        answer: 'Exercitation sit eiusmod enim officia exercitation eiusmod sunt eiusmod excepteur ad commodo eiusmod qui proident quis aliquip excepteur sit cillum occaecat non dolore sit in labore ut duis esse duis.\n\nConsequat sunt voluptate consectetur dolor laborum enim nostrud deserunt incididunt sint veniam laboris sunt amet velit anim duis aliqua sunt aliqua aute qui nisi mollit qui irure ullamco aliquip laborum.',
    },
    {
        id: '0795a74f-7a84-4edf-8d66-296cdef70003',
        categoryId: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
        question: 'How to contact an author',
        answer: 'Minim commodo cillum do id qui irure aliqua laboris excepteur laboris magna enim est lorem consectetur tempor laboris proident proident eu irure dolor eiusmod in officia lorem quis laborum ullamco.\n\nQui excepteur ex sit esse dolore deserunt ullamco occaecat laboris fugiat cupidatat excepteur laboris amet dolore enim velit ipsum velit sint cupidatat consectetur cupidatat deserunt sit eu do ullamco quis.',
    },
    {
        id: '05532574-c102-4228-89a8-55fff32ec6fc',
        categoryId: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
        question: 'Extending and renewing item support',
        answer: 'Reprehenderit anim consectetur anim dolor magna consequat excepteur tempor enim duis magna proident ullamco aute voluptate elit laborum mollit labore id ex lorem est mollit do qui ex labore nulla.\n\nUt proident elit proident adipisicing elit fugiat ex ullamco dolore excepteur excepteur labore laborum sunt ipsum proident magna ex voluptate laborum voluptate sint proident eu reprehenderit non excepteur quis eiusmod.',
    },
    {
        id: 'b3917466-aa51-4293-9d5b-120b0ce6635c',
        categoryId: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
        question: 'Rating or review removal policy',
        answer: 'Ipsum officia mollit qui laboris sunt amet aliquip cupidatat minim non elit commodo eiusmod labore mollit pariatur aute reprehenderit ullamco occaecat enim pariatur aute amet occaecat incididunt irure ad ut.\n\nIncididunt cupidatat pariatur magna sint sit culpa ad cupidatat cillum exercitation consequat minim pariatur consectetur aliqua non adipisicing magna ad nulla ea do est nostrud eu aute id occaecat ut.',
    },
    {
        id: '2f2fb472-24d4-4a00-aa80-d513fa6c059c',
        categoryId: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
        question: 'Purchasing supported and unsupported items',
        answer: 'Dolor cupidatat do qui in tempor dolor magna magna ut dolor est aute veniam consectetur enim sunt sunt duis magna magna aliquip id reprehenderit dolor in veniam ullamco incididunt occaecat.\n\nId duis pariatur anim cillum est sint non veniam voluptate deserunt anim nostrud duis voluptate occaecat elit ut veniam voluptate do qui est ad velit irure sint lorem ullamco aliqua.',
    },
    {
        id: '2fffd148-7644-466d-8737-7dde88c54154',
        categoryId: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
        question: 'I haven\'t received a response from the author',
        answer: 'Velit commodo pariatur ullamco elit sunt dolor quis irure amet tempor laboris labore tempor nisi consectetur ea proident dolore culpa nostrud esse amet commodo do esse laboris laboris in magna.\n\nAute officia labore minim laborum irure cupidatat occaecat laborum ex labore ipsum aliqua cillum do exercitation esse et veniam excepteur mollit incididunt ut qui irure culpa qui deserunt nostrud tempor.',
    },
    {
        id: '24a1034e-b4d6-4a86-a1ea-90516e87e810',
        categoryId: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
        question: 'Responding to requests outside of support',
        answer: 'Exercitation eu in officia lorem commodo pariatur pariatur nisi consectetur qui elit in aliquip et ullamco duis nostrud aute laborum laborum est dolor non qui amet deserunt ex et aliquip.\n\nProident consectetur eu amet minim labore anim ad non aute duis eiusmod sit ad elit magna do aliquip aliqua laborum dolor laboris ea irure duis mollit fugiat tempor eu est.',
    },
];
export const guideCategories = [
    {
        id: 'que-es-unexa',
        slug: 'que-es-unexa',
        title: '01. ¿Qué es Unexa?',
    },
    {
        id: 'ingreso',
        slug: 'ingreso',
        title: '02. Registro e Ingreso',
    },
    {
        id: 'financiadores',
        slug: 'financiadores',
        title: '03. Financiadores',
    },
    {
        id: 'prestadores',
        slug: 'prestadores',
        title: '04. Prestadores',
    },
    {
        id: 'lugares-atencion',
        slug: 'lugares-atencion',
        title: '05. Lugares de atención',
    },
    {
        id: 'transacciones',
        slug: 'transacciones',
        title: '06. Transacciones',
    },
    {
        id: 'pasaportes',
        slug: 'pasaportes',
        title: '07. Pasaportes',
    },
    {
        id: 'tickets',
        slug: 'tickets',
        title: '08. Tickets',
    },
    {
        id: 'transcodificaciones',
        slug: 'transcodificaciones',
        title: '09. Transcodificaciones',
    },
    {
        id: 'sistemas',
        slug: 'sistemas',
        title: '10. Sistemas',
    },
    {
        id: 'pruebas',
        slug: 'pruebas',
        title: '11. Pruebas',
    },
    {
        id: 'contactos',
        slug: 'contactos',
        title: '12. Contactos',
    },
    {
        id: 'usuarios',
        slug: 'usuarios',
        title: '13. Usuarios',
    },
    {
        id: 'notificaciones',
        slug: 'notificaciones',
        title: '14. Notificaciones',
    },
    {
        id: 'admin-iis',
        slug: 'admin-iis',
        title: '15. Administración de los IIS',
    },
    {
        id: 'asociaciones',
        slug: 'asociaciones',
        title: '16. Asociaciones',
    },
    
];
export const guides = [

    {
        id: 'que-es-unexa',
        categoryId: 'que-es-unexa',
        slug: 'que-es-unexa',
        title: '¿Qué es Unexa?',
        subtitle: 'Introducción general al funcionamiento de la plataforma.',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">¿Qué es Unexa?</h2>

            <p class="mt-4 w-full">
                Unexa es una plataforma de gestión para el <strong>ABM de prestadores</strong>, que permite <strong>validar, dar de alta, actualizar y administrar su información.</strong>
            </p>
            <p class="mt-4 w-full">
                A la vez, es la herramienta operativa que utiliza el equipo de <strong>soporte</strong> para <strong>atender usuarios, abrir, gestionar y modificar tickets</strong>, y dar seguimiento a sus solicitudes.
                 </p>

            <img class="mt-2" src="assets/images/guia/01-que-es-unexa/1.png" alt="Vista general de Unexa">

        `,
    },
    {
        id: 'alta-de-usuarios',
        categoryId: 'ingreso',
        slug: 'alta-de-usuarios',
        title: 'Alta de usuarios',
        subtitle: 'Cómo se crean nuevos usuarios dentro de Unexa.',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Alta de usuarios</h2>

            <p class="mt-4 w-full">
                El acceso a Unexa se gestiona de forma interna.
            </p>
            <p class="mt-4 w-full">
                Los <strong>nuevos usuarios no pueden registrarse por cuenta propia</strong>, sino que deben ser dados de alta por un administrador del sistema.
                </p>

            <p class="mt-4 w-full">
                El administrador es responsable de:
            </p>

            <ul class="ml-8 mt-4 w-full ul-list">
                <li > Crear el usuario.</li>
                <li> Asignar el rol correspondientes.</li>
            </ul>

            <img class="svg-size mt-4"  src="assets/images/guia/02-registro-e-ingreso/alta-usuarios.svg" alt="Alta de Unexa">

        `,
    },
    {
        id: 'ingreso-a-la-plataforma',
        categoryId: 'ingreso',
        slug: 'ingreso-a-la-plataforma',
        title: 'Ingreso a la plataforma',
        subtitle: 'Cómo acceder a Unexa con un usuario ya creado.',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Alta de usuarios</h2>

            <p class="mt-4 w-full">
                Una vez que el usuario fue dado de alta por un administrador, puede ingresar a Unexa con las credenciales asignadas.
            </p>

            <p class="mt-4 w-full">
                Para acceder:
            </p>
             <ol class="ml-8 mt-4 w-full ol-list">
                <li> Ingresar a Unexa.</li>
                <li> Completar los datos solicitados.</li>
                <li> Presionar el botón de <strong>Iniciar sesión.</strong></li>
            </ol>
            <p class="mt-4 w-full">
                Si los datos son correctos, el sistema permitirá acceder a la plataforma según el rol y permisos asignados.
                </p>

           <img class="mt-2" src="assets/images/guia/02-registro-e-ingreso/1.png" alt="Ingreso de Unexa">
        `,
    },

    {
        id: 'financiadores',
        categoryId: 'financiadores',
        slug: 'financiadores',
        title: 'Financiadores',
        subtitle: 'Consultar y buscar los financiadores registrados en Unexa.',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Financiadores</h2>

            <p class="mt-4 w-full">
                <strong>Financiadores</strong> permite consultar y buscar los financiadores registrados en Unexa.
            </p>

            <p class="mt-4 w-full">
                Desde esta vista es posible acceder al padrón de financiadores y visualizar su información principal de forma rápida y ordenada.
            </p>
            <p class="mt-4 w-full">
                El usuario puede:
            </p>

            <ul class="ml-8 mt-4 w-full ul-list">
                <li >Buscar financiadores por sigla, nombre o CUIT.</li>
                <li> Visualizar los resultados disponibles en pantalla.</li>
                <li> Consultar la información principal de cada financiador.</li>
            </ul>

           <img class="mt-4" src="assets/images/guia/03-financiadores/1.png" alt="Ingreso de Unexa">
        `,
    },
    {
        id: 'prestadores',
        categoryId: 'prestadores',
        slug: 'prestadores',
        title: 'Prestadores',
        subtitle: 'Buscar y consultar los prestadores registrados en Unexa.',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Prestadores</h2>

            <p class="mt-4 w-full">
                Permite buscar y consultar los prestadores registrados en Unexa.
            </p>

            <p class="mt-4 w-full">
                Desde esta vista, el usuario puede realizar la búsqueda de un prestador mediante los filtros disponibles, visualizar los resultados obtenidos y acceder al detalle de cada uno.
            </p>
            <p class="mt-4 w-full">
                Además, desde el botón <strong>Nueva Alta</strong> es posible iniciar el alta de un nuevo prestador.
            </p>

            

           <img class="mt-4" src="assets/images/guia/04-prestadores/1.png" alt="Ingreso de Unexa">
        `,
    },
    {
        id: 'buscar-prestador',
        categoryId: 'prestadores',
        slug: 'buscar-prestador',
        title: 'Buscar prestador',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Buscar prestador</h2>

            <p class="mt-4 w-full">
                Para localizar un prestador:
            </p>
            <img class="mt-4" src="assets/images/guia/04-prestadores/buscar-1.png" alt="Ingreso de Unexa">
            <p class="mt-4 w-full">
                Debe seleccionar un criterio de búsqueda, ingresar el dato correspondiente y presionar <strong>Buscar.</strong>
            </p>
            <img class="mt-4" src="assets/images/guia/04-prestadores/buscar-2.png" alt="Ingreso de Unexa">
            <p class="mt-4 w-full">
                Una vez realizada la búsqueda, el sistema muestra los registros que coinciden con la información ingresada.
            </p>
        `,
    },

    {
        id: 'nuevo-prestador',
        categoryId: 'prestadores',
        slug: 'nuevo-prestador',
        title: 'Alta de un prestador',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
          <h2 class="mt-4 w-full">Alta de un prestador</h2>

            <p class="mt-4 w-full">
                Permite dar de alta un nuevo prestador.
            </p>

            <p class="mt-4 w-full">
                El proceso se realiza en tres pasos:
            </p>

            <div class="mt-6 grid w-full grid-cols-1 items-center gap-4 rounded-lg border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-700 dark:bg-neutral-800 lg:grid-cols-[minmax(0,720px)_minmax(260px,420px)]">
    <img
        class="w-full max-w-full h-auto rounded-lg object-contain img-size"
        src="assets/images/guia/05-lugares-de-atención/alta-1.png"
        alt="Nuevo lugar de atención - paso 1">

    <p class="text-secondary">
        <strong>Información del prestador: </strong> Se cargan los datos generales del prestador, como <strong>CUIT, razón social, especialidad y matrícula</strong>.
    </p>
</div>

<div class="mt-6 grid w-full grid-cols-1 items-center gap-4 rounded-lg border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-700 dark:bg-neutral-800 lg:grid-cols-[minmax(0,720px)_minmax(260px,420px)]">
    <img
        class="w-full max-w-full h-auto rounded-lg object-contain img-size"
        src="assets/images/guia/05-lugares-de-atención/alta-2.png"
        alt="Nuevo lugar de atención - paso 2">

    <p class="text-secondary">
        <strong>Agregar información de contacto:</strong> Se completa la información de contacto asociada al prestador, como medio de contacto, teléfono, nombre, tipo de contacto y observaciones.
    </p>
</div>
<div class="mt-6 grid w-full grid-cols-1 items-center gap-4 rounded-lg border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-700 dark:bg-neutral-800 lg:grid-cols-[minmax(0,720px)_minmax(260px,420px)]">
    <img
        class="w-full max-w-full h-auto rounded-lg object-contain img-size"
        src="assets/images/guia/05-lugares-de-atención/alta-3.png"
        alt="Nuevo lugar de atención - paso 2">

    <p class="text-secondary">
       <strong>Datos del financiador y lugar de atención: </strong> Se selecciona el financiador y se completan los datos necesarios para su vinculación con el prestador, como código, filial, delegación, operador y terminal.<br><br> Se agregan los datos del lugar de atención correspondiente.
    </p>
</div>
<p class="mt-4 w-full">
    Una vez completados los datos requeridos en cada etapa, es posible finalizar el alta del nuevo prestador.
</p>   
        `,
    },

    {
        id: 'detalle-prestador',
        categoryId: 'prestadores',
        slug: 'detalle-prestador',
        title: 'Detalles del prestador',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Detalles del prestador</h2>

            <p class="mt-4 w-full">
                Reúne la información principal del prestador seleccionado.
            </p>
            <p class="mt-4 w-full">
                Desde este panel, el usuario puede consultar los datos generales del prestador, visualizar su estado, revisar la configuración asociada, gestionar los contactos vinculados y acceder a sus lugares de atención.
            </p>
            <p class="mt-4 w-full">
                También es posible editar los datos generales del prestador y administrar servicios asociados al prestador.
            </p>
            <img class="mt-4" src="assets/images/guia/04-prestadores/detalle-1.png" alt="Ingreso de Unexa">
           
        `,
    },
    {
        id: 'config-nuvalid',
        categoryId: 'prestadores',
        slug: 'config-nuvalid',
        title: 'Configuración de Nuvalid',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Configuración de Nuvalid</h2>

            <p class="mt-4 w-full">
                Permite visualizar la configuración asociada al prestador dentro de Nuvalid.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, el usuario puede consultar la cantidad de financiadores asociados, las matrículas registradas, las instalaciones vinculadas y sus licencias.
            </p>
            
            <img class="mt-4" src="assets/images/guia/04-prestadores/configuracion-2.png" alt="Ingreso de Unexa">
           
        `,
    },
    {
        id: 'excepciones',
        categoryId: 'prestadores',
        slug: 'excepciones',
        title: 'Excepciones',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Excepciones</h2>

            <p class="mt-4 w-full">
                Permite poder <strong>ver, agregar y eliminar</strong> las excecpiones vinculadas a un prestador.
            </p>
            
            <img class="mt-4 max-width-540" src="assets/images/guia/04-prestadores/excepciones-1.png" alt="Ingreso de Unexa">
           
        `,
    },
    {
        id: 'editar-prestador',
        categoryId: 'prestadores',
        slug: 'editar-prestador',
        title: 'Editar prestador',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Editar prestador</h2>

            <p class="mt-4 w-full">
                Permite modificar los <strong>datos generales del prestador</strong>.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible actualizar la información principal del registro, como el <strong>CUIT, la razón social, la especialidad y la matrícula</strong>.
            </p>
            <p class="mt-4 w-full">
                Antes de confirmar los cambios, el sistema muestra un mensaje de advertencia indicando que la actualización realizada no puede revertirse.
            </p>
            
            <img class="mt-4" src="assets/images/guia/04-prestadores/editar-1.png" alt="Ingreso de Unexa">
           
        `,
    },
    {
        id: 'nuevo-la',
        categoryId: 'prestadores',
        slug: 'nuevo-la',
        title: 'Nuevo lugar de atención',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
          <h2 class="mt-4 w-full">Nuevo lugar de atención</h2>

            <p class="mt-4 w-full">
                Permite dar de alta un nuevo lugar de atención asociado al prestador.
            </p>

            <p class="mt-4 w-full">
                El proceso se realiza en tres pasos:
            </p>

            <div class="mt-6 grid w-full grid-cols-1 items-center gap-4 rounded-lg border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-700 dark:bg-neutral-800 lg:grid-cols-[minmax(0,720px)_minmax(260px,420px)]">
    <img
        class="w-full max-w-full h-auto rounded-lg object-contain img-size"
        src="assets/images/guia/04-prestadores/nuevo-la-1.png"
        alt="Nuevo lugar de atención - paso 1">

    <p class="text-secondary">
        <strong>Agregar información de contacto:</strong> se completa o asocia la información de contacto vinculada al nuevo lugar de atención.
    </p>
</div>

<div class="mt-6 grid w-full grid-cols-1 items-center gap-4 rounded-lg border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-700 dark:bg-neutral-800 lg:grid-cols-[minmax(0,720px)_minmax(260px,420px)]">
    <img
        class="w-full max-w-full h-auto rounded-lg object-contain img-size"
        src="assets/images/guia/04-prestadores/nuevo-la-2.png"
        alt="Nuevo lugar de atención - paso 2">

    <p class="text-secondary">
        <strong>Asignar financiador:</strong> se selecciona el financiador y se completan los datos necesarios para su vinculación.
    </p>
</div>
<div class="mt-6 grid w-full grid-cols-1 items-center gap-4 rounded-lg border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-700 dark:bg-neutral-800 lg:grid-cols-[minmax(0,720px)_minmax(260px,420px)]">
    <img
        class="w-full max-w-full h-auto rounded-lg object-contain img-size"
        src="assets/images/guia/04-prestadores/nuevo-la-3.png"
        alt="Nuevo lugar de atención - paso 2">

    <p class="text-secondary">
       <strong>Asignar lugar de atención:</strong> se cargan los datos del nuevo lugar de atención, como licencia, domicilio, referencia y pasaporte
    </p>
</div>
<p class="mt-4 w-full">
    Al completar la información requerida en cada etapa, el sistema habilita la creación del nuevo lugar de atención.
</p>   
        `,
    },
    {
        id: 'asignar-contacto',
        categoryId: 'prestadores',
        slug: 'asignar-contacto',
        title: 'Asignar contacto',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Asignar contacto</h2>

            <p class="mt-4 w-full">
                En esta pestaña, se busca un contacto existente y se lo asigna al prestador.
            </p>
            <p class="mt-4 w-full">
                Para realizar la búsqueda, se debe ingresar al menos 9 caracteres. Luego, se selecciona el contacto deseado y se confirma la asignación.
           </p>
           
            <img class="mt-4" src="assets/images/guia/04-prestadores/asignar-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'crear-asignar-contacto',
        categoryId: 'prestadores',
        slug: 'crear-asignar-contacto',
        title: 'Crear y asignar contacto',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Crear y asignar contacto</h2>

            <p class="mt-4 w-full">
                Se carga la información de un nuevo contacto y luego se seleccionan los lugares de atención a los que quedará asociado.
            </p>
            <p class="mt-4 w-full">
                El proceso se realiza en dos pasos:
            </p>
            <ol class="ml-8 mt-4 w-full ol-list">
                <li><strong>Rellenar la información de contacto:</strong> Se completan los datos del nuevo contacto, como medio de contacto, teléfono, nombre, tipo de contacto y observaciones.</li>
                <li><strong>Seleccionar los lugares de atención:</strong> En este paso, se eligen los lugares de atención a los que se asociará el nuevo contacto.</li>
                
            </ol>
            
            <img class="mt-4" src="assets/images/guia/04-prestadores/crear-asignar-1.png" alt="Ingreso de Unexa">
        `,
    },
    {
        id: 'lugar-atencion',
        categoryId: 'prestadores',
        slug: 'lugar-atencion',
        title: 'Lugar de atención',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Lugar de atención</h2>

            <p class="mt-4 w-full">
                Permite consultar la información del lugar de atención seleccionado y revisar sus datos asociados.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, el usuario puede visualizar los <strong>datos generales del lugar de atención</strong>, la información de contacto, los financiadores vinculados y los últimos tickets registrados.
           </p>
           <p class="mt-4 w-full">
                También es posible acceder a acciones relacionadas, como consultar contactos, visualizar la configuración de Nuvalid Lite, asignar o consultar pasaportes y revisar los tickets asociados.
            </p>
           
            <img class="mt-4" src="assets/images/guia/04-prestadores/lugar-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'lugar-atencion',
        categoryId: 'lugares-atencion',
        slug: 'lugar-atencion',
        title: 'Lugares de atención',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Lugares de atención</h2>

            <p class="mt-4 w-full">
                Permite buscar y consultar los lugares de atención registrados en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, el usuario puede realizar la búsqueda de lugares de atención mediante los filtros disponibles, visualizar los resultados obtenidos y acceder al detalle de cada uno.
           </p>
           
           
            <img class="mt-4" src="assets/images/guia/05-lugares-de-atención/lugar-atencion-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'buscar-la',
        categoryId: 'lugares-atencion',
        slug: 'buscar-la',
        title: 'Buscar lugar de atención',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Buscar lugar de atención</h2>

            <p class="mt-4 w-full">
                Para localizar un lugar de atención:
            </p>
            <img class="mt-4" src="assets/images/guia/05-lugares-de-atención/buscar-1.png" alt="Ingreso de Unexa">
            <p class="mt-4 w-full">
                Debe seleccionar un criterio de búsqueda, ingresar el dato correspondiente y presionar <strong>Buscar.</strong>
            </p>
            <img class="mt-4" src="assets/images/guia/05-lugares-de-atención/buscar-2.png" alt="Ingreso de Unexa">
            <p class="mt-4 w-full">
                Una vez realizada la búsqueda, el sistema muestra los registros que coinciden con la información ingresada.
            </p>
        `,
    },
    {
        id: 'detalle',
        categoryId: 'lugares-atencion',
        slug: 'detalle',
        title: 'Detalles del lugar de atención',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Detalles del lugar de atención</h2>

            <p class="mt-4 w-full">
                Reúne la información principal del prestador seleccionado.
            </p>
            <p class="mt-4 w-full">
                Desde este panel, el usuario puede consultar los datos generales del prestador, visualizar su estado, revisar la configuración asociada, gestionar los contactos vinculados y acceder a sus lugares de atención.
           </p>
           <p class="mt-4 w-full">
                También es posible editar los datos generales del prestador y administrar servicios asociados al prestador.
            </p>
           
           
            <img class="mt-4" src="assets/images/guia/05-lugares-de-atención/detalle-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'excepcion',
        categoryId: 'lugares-atencion',
        slug: 'excepcion',
        title: 'Excepción mensajería',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Excepción mensajería</h2>

            <p class="mt-4 w-full">
                Permite consultar la excepción de mensajería configurada para el lugar de atención seleccionado.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible visualizar los datos del lugar de atención, como <strong>domicilio, licencia y tipo de excepción</strong>, y eliminar la excepción registrada si corresponde.
           </p>
           
           
           
            <img class="mt-4" src="assets/images/guia/05-lugares-de-atención/excepcion-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'editar',
        categoryId: 'lugares-atencion',
        slug: 'editar',
        title: 'Editar lugar de atención',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Editar lugar de atención</h2>

            <p class="mt-4 w-full">
                Permite modificar los datos generales del lugar de atención seleccionado.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible actualizar información como <strong>la licencia, el domicilio, el piso, el departamento, la sucursal y la referencia.</strong>
           </p>
           <p class="mt-4 w-full">
                Antes de confirmar los cambios, el sistema muestra un mensaje de advertencia indicando que la actualización  realizada no puede revertirse.
            </p>
           
           
           
            <img class="mt-4" src="assets/images/guia/05-lugares-de-atención/editar-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'envio',
        categoryId: 'lugares-atencion',
        slug: 'envio',
        title: 'Envío de email',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Envío de email</h2>

            <p class="mt-4 w-full">
                Permite ingresar los datos necesarios para enviar los instructivos al destinatario seleccionado.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, se completan <strong>el nombre y el correo electrónico</strong> del destinatario antes de confirmar el envío.
           </p>                    
           
           
            <img class="mt-4" src="assets/images/guia/05-lugares-de-atención/envio-mail-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'sistemas',
        categoryId: 'lugares-atencion',
        slug: 'sistemas',
        title: 'Sistemas',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Sistemas</h2>

            <p class="mt-4 w-full">
                Permite consultar los softwares asociados al lugar de atención seleccionado.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible visualizar la cantidad de sistemas registrados, su nombre y la cantidad de contactos vinculados. 
           </p>  
           <p class="mt-4 w-full">
                En caso de no existir softwares asociados, el sistema lo informa en pantalla.
            </p>                  
           
           
            <img class="mt-4" src="assets/images/guia/05-lugares-de-atención/sistemas-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'nuevo-prestador',
        categoryId: 'lugares-atencion',
        slug: 'nuevo-prestador',
        title: 'Alta de un prestador',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
          <h2 class="mt-4 w-full">Alta de un prestador</h2>

            <p class="mt-4 w-full">
                Permite dar de alta un nuevo prestador.
            </p>

            <p class="mt-4 w-full">
                El proceso se realiza en tres pasos:
            </p>

            <div class="mt-6 grid w-full grid-cols-1 items-center gap-4 rounded-lg border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-700 dark:bg-neutral-800 lg:grid-cols-[minmax(0,720px)_minmax(260px,420px)]">
    <img
        class="w-full max-w-full h-auto rounded-lg object-contain img-size"
        src="assets/images/guia/05-lugares-de-atención/alta-1.png"
        alt="Nuevo lugar de atención - paso 1">

    <p class="text-secondary">
        <strong>Información del prestador: </strong> Se cargan los datos generales del prestador, como <strong>CUIT, razón social, especialidad y matrícula</strong>.
    </p>
</div>

<div class="mt-6 grid w-full grid-cols-1 items-center gap-4 rounded-lg border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-700 dark:bg-neutral-800 lg:grid-cols-[minmax(0,720px)_minmax(260px,420px)]">
    <img
        class="w-full max-w-full h-auto rounded-lg object-contain img-size"
        src="assets/images/guia/05-lugares-de-atención/alta-2.png"
        alt="Nuevo lugar de atención - paso 2">

    <p class="text-secondary">
        <strong>Agregar información de contacto:</strong> Se completa la información de contacto asociada al prestador, como medio de contacto, teléfono, nombre, tipo de contacto y observaciones.
    </p>
</div>
<div class="mt-6 grid w-full grid-cols-1 items-center gap-4 rounded-lg border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-700 dark:bg-neutral-800 lg:grid-cols-[minmax(0,720px)_minmax(260px,420px)]">
    <img
        class="w-full max-w-full h-auto rounded-lg object-contain img-size"
        src="assets/images/guia/05-lugares-de-atención/alta-3.png"
        alt="Nuevo lugar de atención - paso 2">

    <p class="text-secondary">
       <strong>Datos del financiador y lugar de atención: </strong> Se selecciona el financiador y se completan los datos necesarios para su vinculación con el prestador, como código, filial, delegación, operador y terminal.<br><br> Se agregan los datos del lugar de atención correspondiente.
    </p>
</div>
<p class="mt-4 w-full">
    Una vez completados los datos requeridos en cada etapa, es posible finalizar el alta del nuevo prestador.
</p>   
        `,
    },
    {
        id: 'asignar',
        categoryId: 'lugares-atencion',
        slug: 'asignar',
        title: 'Asignar contacto',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Asignar contacto</h2>

            <p class="mt-4 w-full">
                En esta pestaña, se busca un contacto existente y se lo asigna al lugar de atención.
            </p>
            <p class="mt-4 w-full">
                Para realizar la búsqueda, se debe ingresar al menos 9 caracteres. Luego, se selecciona el contacto deseado y se confirma la asignación.
           </p>               
           
           
            <img class="mt-4" src="assets/images/guia/05-lugares-de-atención/asignar-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'crear-asignar',
        categoryId: 'lugares-atencion',
        slug: 'crear-asignar',
        title: 'Crear y asignar contacto',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Crear y asignar contacto</h2>

            <p class="mt-4 w-full">
                Se carga la información de un nuevo contacto y luego se seleccionan los lugares de atención a los que quedará asociado.
            </p>
            <p class="mt-4 w-full">
                El proceso se realiza en dos pasos:
           </p> 
           <ol class="ml-8 mt-4 w-full ol-list">
                <li><strong>Rellenar la información de contacto:</strong> Se completan los datos del nuevo contacto, como medio de contacto, teléfono, nombre, tipo de contacto y observaciones.</li>
                <li><strong>Seleccionar los lugares de atención:</strong> En este paso, se eligen los lugares de atención a los que se asociará el nuevo contacto.</li>
                
            </ol>              
           
           
            <img class="mt-4" src="assets/images/guia/05-lugares-de-atención/crear-asignar-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'prestador',
        categoryId: 'lugares-atencion',
        slug: 'prestador',
        title: 'Prestador',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Prestador</h2>

            <p class="mt-4 w-full">
                Permite consultar los prestadores asociados al lugar de atención seleccionado.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible visualizar la información principal de cada prestador, como <strong>CUIT, especialidad, matrícula y estado, además de acceder a configuraciones, contactos, contratos, pasaportes, financiadores y tickets vinculados.</strong>
           </p>               
           
           
            <img class="mt-4" src="assets/images/guia/05-lugares-de-atención/prestador-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'transacciones',
        categoryId: 'transacciones',
        slug: 'transacciones',
        title: 'Transacciones',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Transacciones</h2>

            <p class="mt-4 w-full">
                Permite consultar y auditar las transacciones registradas en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible filtrar la información por criterio de búsqueda y rango de fechas, y visualizar los resultados obtenidos en una tabla con el detalle de cada transacción.
           </p>               
           
           
            <img class="mt-4" src="assets/images/guia/06-transacciones/transacciones-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'buscar-transaccion',
        categoryId: 'transacciones',
        slug: 'buscar-transaccion',
        title: 'Buscar transacción',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Buscar transacción</h2>

            <p class="mt-4 w-full">
                Para localizar una transacción:
            </p>
            <img class="mt-4" src="assets/images/guia/06-transacciones/buscar-1.png" alt="Ingreso de Unexa">
            <p class="mt-4 w-full">
                Debe seleccionar un criterio de búsqueda, ingresar el dato correspondiente y presionar <strong>Buscar.</strong>
            </p>
            <img class="mt-4" src="assets/images/guia/06-transacciones/buscar-2.png" alt="Ingreso de Unexa">
            <p class="mt-4 w-full">
                Una vez realizada la búsqueda, el sistema muestra los registros que coinciden con la información ingresada.
          </p>
        `,
    },
    {
        id: 'carga-masiva',
        categoryId: 'transacciones',
        slug: 'carga-masiva',
        title: 'Carga masiva',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Carga masiva</h2>

            <p class="mt-4 w-full">
                Permite cargar múltiples transacciones mediante un archivo en formato CSV, XLS o XLSX.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, se debe seleccionar el <strong>tipo de transacción</strong>, completar la <strong>sucursal del prestador</strong> cuando corresponda y adjuntar el archivo a procesar. 
           </p>  
           <p class="mt-4 w-full">
                Además, es posible descargar una plantilla de ejemplo para preparar la carga.
            </p>             
           
           
            <img class="mt-4" src="assets/images/guia/06-transacciones/carga-masiva.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'detalle',
        categoryId: 'transacciones',
        slug: 'detalle',
        title: 'Detalles de la transacción',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Detalles de la transacción</h2>

            <p class="mt-4 w-full">
                Permite consultar la información completa de la transacción seleccionada.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible visualizar el detalle técnico de la operación, incluyendo los datos del requerimiento, la respuesta obtenida y la información asociada a la transacción.
           </p>             
           
           
            <img class="mt-4" src="assets/images/guia/06-transacciones/detalle-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'ver-ticket',
        categoryId: 'transacciones',
        slug: 'ver-ticket',
        title: 'Ver ticket',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Ver ticket</h2>

            <p class="mt-4 w-full">
                Permite consultar el comprobante generado para la transacción seleccionada.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible visualizar la información principal del ticket, como financiador, tipo de operación, estado de la solicitud, datos del prestador, datos del afiliado, fecha de atención y detalle de la prestación.
           </p>             
           
           
            <img class="mt-4" src="assets/images/guia/06-transacciones/ver-ticket.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'pasaportes',
        categoryId: 'pasaportes',
        slug: 'pasaportes',
        title: 'Pasaportes',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Pasaportes</h2>

            <p class="mt-4 w-full">
                Permite buscar, consultar y gestionar los pasaportes registrados en Unexa.
            </p>
            <p class="mt-4 w-full">
               Desde esta vista, es posible realizar búsquedas según un criterio definido, visualizar los resultados en una tabla y consultar la información principal de cada pasaporte, como <strong>token, sucursal, descripción, estado, contactos y softwares</strong> asociados.
           </p>             
           
           
            <img class="mt-4" src="assets/images/guia/07-pasaportes/pasaporte-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'agregar-pasaporte',
        categoryId: 'pasaportes',
        slug: 'agregar-pasaporte',
        title: 'Agregar pasaporte',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Agregar pasaporte</h2>

            <p class="mt-4 w-full">
                Permite registrar un nuevo pasaporte en Unexa.
            </p>
            <p class="mt-4 w-full">
               Desde esta vista, se completan los datos necesarios para su creación, como la <strong>sucursal, la descripción y los sistemas</strong> asociados.
           </p>             
           
           
            <img class="mt-4" src="assets/images/guia/07-pasaportes/agregar-pasaporte-1.png" alt="Ingreso de Unexa">           
        `,
    },
     {
        id: 'editar-pasaporte',
        categoryId: 'pasaportes',
        slug: 'editar-pasaporte',
        title: 'Editar pasaporte',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Editar pasaporte</h2>

            <p class="mt-4 w-full">
                Permite consultar la información completa de la transacción seleccionada.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible visualizar el detalle técnico de la operación, incluyendo los datos del requerimiento, la respuesta obtenida y la información asociada a la transacción.
           </p>             
           
           
            <img class="mt-4" src="assets/images/guia/07-pasaportes/editar-pasaporte-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'asignar-pasaporte',
        categoryId: 'pasaportes',
        slug: 'asignar-pasaporte',
        title: 'Asignar un pasaporte',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Asignar un pasaporte</h2>

            <p class="mt-4 w-full">
                Permite vincular un prestador al pasaporte seleccionado.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, se debe ingresar el <strong>CUIT del prestador</strong>, seleccionar el <strong>lugar de atención</strong> correspondiente y consultar los datos del <strong>token</strong> y la <strong>sucursal</strong> asociados al pasaporte.
           </p>             
           
           
            <img class="mt-4" src="assets/images/guia/07-pasaportes/asignar-pasaporte-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'agregar-sucursal',
        categoryId: 'pasaportes',
        slug: 'agregar-sucursal',
        title: 'Agregar sucursal',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Agregar sucursal</h2>

            <p class="mt-4 w-full">
                Permite asociar una nueva sucursal al pasaporte seleccionado.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, se completan los datos de la sucursal y su descripción antes de confirmar la asociación.
           </p>             
           
           
            <img class="mt-4" src="assets/images/guia/07-pasaportes/agregar-sucursal-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'baja-pasaporte',
        categoryId: 'pasaportes',
        slug: 'baja-pasaporte',
        title: 'Dar de baja pasaporte',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Dar de baja pasaporte</h2>

            <p class="mt-4 w-full">
                Permite inhabilitar el pasaporte seleccionado.
            </p>
            <p class="mt-4 w-full">
                Antes de confirmar la acción, se informa que el pasaporte quedará inhabilitado en todos los lugares de atención a los que se encuentre asociado.
           </p>             
           
           
            <img class="mt-4" src="assets/images/guia/07-pasaportes/baja-pasaporte.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'tickets',
        categoryId: 'tickets',
        slug: 'tickets',
        title: 'Tickets',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Tickets</h2>

            <p class="mt-4 w-full">
                Permite buscar, consultar y gestionar los reclamos o tickets registrados en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible filtrar los tickets según un criterio de búsqueda, visualizar los resultados en una tabla y consultar la información principal de cada registro, como <strong>número de ticket, CUIT, detalle, fecha, estado y lugar de atención</strong>.
           </p>             
           
            <img class="mt-4" src="assets/images/guia/08-tickets/tickets-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'buscar-ticket',
        categoryId: 'tickets',
        slug: 'buscar-ticket',
        title: 'Buscar ticket',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Buscar ticket</h2>

            <p class="mt-4 w-full">
                Para localizar un ticket:
            </p>
            <img class="mt-4" src="assets/images/guia/08-tickets/buscar-ticket-1.png" alt="Ingreso de Unexa">
            <p class="mt-4 w-full">
                Debe seleccionar un criterio de búsqueda, ingresar el dato correspondiente y presionar<strong>Buscar.</strong>
            </p>
            <img class="mt-4" src="assets/images/guia/08-tickets/buscar-ticket-2.png" alt="Ingreso de Unexa">
            <p class="mt-4 w-full">
                Una vez realizada la búsqueda, el sistema muestra los registros que coinciden con la información ingresada.
          </p>        
        `,
    },
    {
        id: 'agregar-ticket',
        categoryId: 'tickets',
        slug: 'agregar-ticket',
        title: 'Agregar ticket',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Agregar ticket</h2>

            <p class="mt-4 w-full">
                Permite registrar un nuevo ticket en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, se completan los datos del <strong>operador</strong>, la información del <strong>prestador</strong>, la <strong>tipificación</strong>, la <strong>descripción</strong>, las <strong>etiquetas</strong>, los <strong>datos de contacto</strong> y, si corresponde, la información de la <strong>solución</strong>.
           </p>             
           
            <img class="mt-4" src="assets/images/guia/08-tickets/agregar-ticket.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'detalle-ticket',
        categoryId: 'tickets',
        slug: 'detalle-ticket',
        title: 'Detalle del ticket',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Detalle del ticket</h2>

            <p class="mt-4 w-full">
                Permite consultar la información completa del ticket seleccionado.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible visualizar la <strong>información general</strong> del ticket, los datos del <strong>prestador</strong>, la información de <strong>contacto</strong> y su <strong>estado</strong> actual. Además, se puede acceder a las opciones para <strong>comentar o editar</strong> el ticket.
           </p>             
           
            <img class="mt-4" src="assets/images/guia/08-tickets/detalle-ticket.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'tipificaciones',
        categoryId: 'tickets',
        slug: 'tipificaciones',
        title: 'Tipificaciones',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Tipificaciones</h2>

            <p class="mt-4 w-full">
                Permite buscar, consultar y gestionar las tipificaciones utilizadas en los tickets de Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible realizar búsquedas por nombre, visualizar los resultados en una tabla y consultar la información principal de cada tipificación, como <strong>nombre, descripción y estado.</strong>
           </p>             
           
            <img class="mt-4" src="assets/images/guia/08-tickets/tipificaciones.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'agregar-tipificacion',
        categoryId: 'tickets',
        slug: 'agregar-tipificacion',
        title: 'Agregar tipificación',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Agregar tipificación</h2>

            <p class="mt-4 w-full">
                Permite registrar una nueva tipificación para los tickets de Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, se debe ingresar el <strong>nombre de la tipificación</strong> y, de manera opcional, una descripción para identificarla.
           </p>             
           
            <img class="mt-4" src="assets/images/guia/08-tickets/agregar-tipificacion.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'editar-tipificacion',
        categoryId: 'tickets',
        slug: 'editar-tipificacion',
        title: 'Editar tipificación',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Editar tipificación</h2>

            <p class="mt-4 w-full">
                Permite modificar la información de una tipificación registrada en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible actualizar el <strong>nombre, la descripción y el estado</strong> de la tipificación.
           </p>             
           
            <img class="mt-4" src="assets/images/guia/08-tickets/editar-tipificacion.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'desactivar-tipificacion',
        categoryId: 'tickets',
        slug: 'desactivar-tipificacion',
        title: 'Desactivar tipificación',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Desactivar tipificación</h2>

            <p class="mt-4 w-full">
                Permite desactivar una tipificación registrada en Unexa.
            </p>
            <p class="mt-4 w-full">
                Antes de confirmar la acción, se solicita validación para desactivar la tipificación seleccionada.
           </p>             
           
            <img class="mt-4" src="assets/images/guia/08-tickets/desactivar-tipificacion.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'etiquetas',
        categoryId: 'tickets',
        slug: 'etiquetas',
        title: 'Etiquetas',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Etiquetas</h2>

            <p class="mt-4 w-full">
                Permite buscar, consultar y gestionar las etiquetas utilizadas en los tickets de Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible realizar búsquedas por nombre, visualizar los resultados en una tabla y consultar la información principal de cada etiqueta, como <strong>nombre y estado.</strong>
           </p>             
           
            <img class="mt-4" src="assets/images/guia/08-tickets/etiquetas.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'agregar-etiqueta',
        categoryId: 'tickets',
        slug: 'agregar-etiqueta',
        title: 'Agregar etiqueta',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Agregar etiqueta</h2>

            <p class="mt-4 w-full">
                Permite registrar una nueva etiqueta para los tickets de Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, se debe ingresar el <strong>nombre de la etiqueta</strong> para completar su creación.
           </p>             
           
            <img class="mt-4" src="assets/images/guia/08-tickets/agregar-etiqueta.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'editar-etiqueta',
        categoryId: 'tickets',
        slug: 'editar-etiqueta',
        title: 'Editar etiqueta',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Editar etiqueta</h2>

            <p class="mt-4 w-full">
                Permite modificar la información de una etiqueta registrada en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible actualizar <strong>el nombre y el estado</strong> de la etiqueta.
           </p>             
           
            <img class="mt-4" src="assets/images/guia/08-tickets/editar-etiqueta.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'desactivar-etiqueta',
        categoryId: 'tickets',
        slug: 'desactivar-etiqueta',
        title: 'Desactivar etiqueta',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Desactivar etiqueta</h2>

            <p class="mt-4 w-full">
                Permite desactivar una etiqueta registrada en Unexa.
            </p>
            <p class="mt-4 w-full">
                Antes de confirmar la acción, se solicita validación para desactivar la etiqueta seleccionada.
           </p>             
           
            <img class="mt-4" src="assets/images/guia/08-tickets/desactivar-etiqueta.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'transcodificaciones',
        categoryId: 'transcodificaciones',
        slug: 'transcodificaciones',
        title: 'Transcodificaciones',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Transcodificaciones</h2>

            <p class="mt-4 w-full">
                Permite buscar, consultar y gestionar las transcodificaciones registradas en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible realizar búsquedas por <strong>prestador, domicilio, financiador y códigos de prestación</strong>, además de acceder a las opciones para <strong>agregar</strong> una nueva transcodificación o <strong>cargar un archivo</strong>.
           </p>             
           
            <img class="mt-4" src="assets/images/guia/09-transcodificaciones/transcodificaciones-1.png" alt="Ingreso de Unexa">           
        `,
    },
    {
        id: 'buscar-transcodificacion',
        categoryId: 'transcodificaciones',
        slug: 'buscar-transcodificacion',
        title: 'Buscar transcodificaciones',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Buscar transcodificaciones</h2>

            <p class="mt-4 w-full">
                Permite localizar registros mediante distintos criterios de búsqueda.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible filtrar por <strong>CUIT del prestador, domicilio, financiador, código de prestación del prestador y código de prestación de la obra social.</strong>
           </p>   
           <p class="mt-4 w-full">
                Una vez aplicada la búsqueda, los resultados se muestran en una tabla con la información principal de cada transcodificación.
            </p>          
           
            <img class="mt-4" src="assets/images/guia/09-transcodificaciones/buscar-transcodificaciones-1.png" alt="Ingreso de Unexa">    
            <img class="mt-4" src="assets/images/guia/09-transcodificaciones/buscar-transcodificaciones-2.png" alt="Ingreso de Unexa">          
        `,
    },
    {
        id: 'agregar-transcodificacion',
        categoryId: 'transcodificaciones',
        slug: 'agregar-transcodificacion',
        title: 'Agregar transcodificación',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Agregar transcodificación</h2>

            <p class="mt-4 w-full">
                Permite registrar una nueva transcodificación en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, se completan los datos básicos del <strong>prestador, el lugar de atención, el financiador y los códigos de prestación</strong>, además de la información complementaria asociada a la transcodificación.
           </p>   
                 
           
            <img class="mt-4" src="assets/images/guia/09-transcodificaciones/agregar-transcodificaciones-1.png" alt="Ingreso de Unexa">    
                  
        `,
    },
    {
        id: 'cargar-archivo',
        categoryId: 'transcodificaciones',
        slug: 'cargar-archivo',
        title: 'Cargar archivo',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Cargar archivo</h2>

            <p class="mt-4 w-full">
                Permite crear transcodificaciones en masa mediante la carga de un archivo.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, se debe seleccionar el <strong>financiador</strong> y adjuntar un archivo en formato <strong>CSV, XLS o XLSX</strong> con la información a procesar.
           </p>   
                 
           
            <img class="mt-4" src="assets/images/guia/09-transcodificaciones/cargar-archivo-1.png" alt="Ingreso de Unexa">    
                  
        `,
    },
    {
        id: 'actualizar-transcodificacion',
        categoryId: 'transcodificaciones',
        slug: 'actualizar-transcodificacion',
        title: 'Actualizar transcodificación',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Actualizar transcodificación</h2>

            <p class="mt-4 w-full">
                Permite modificar la información de una transcodificación registrada en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible consultar los datos base del registro, como <strong>financiador, CUIT del prestador y licencia</strong>, y actualizar los <strong>códigos de prestación</strong> y los datos complementarios asociados.
           </p>   
                 
           
            <img class="mt-4" src="assets/images/guia/09-transcodificaciones/actualizar-transcodificaciones-1.png" alt="Ingreso de Unexa">    
                  
        `,
    },
    {
        id: 'eliminar-transcodificacion',
        categoryId: 'transcodificaciones',
        slug: 'eliminar-transcodificacion',
        title: 'Eliminar transcodificación',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Eliminar transcodificación</h2>

            <p class="mt-4 w-full">
                Permite confirmar la eliminación de una transcodificación registrada en Unexa.
            </p>
            <p class="mt-4 w-full">
                Antes de confirmar la acción, se muestra el detalle del registro a eliminar, incluyendo el <strong>CUIT del prestador, el código de prestación del prestador y el código de prestación</strong> de la obra social.
           </p>   
                 
           
            <img class="mt-4" src="assets/images/guia/09-transcodificaciones/eliminar-transcodificaciones-1.png" alt="Ingreso de Unexa">    
                  
        `,
    },
    {
        id: 'sistemas',
        categoryId: 'sistemas',
        slug: 'sistemas',
        title: 'Sistemas',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Sistemas</h2>

            <p class="mt-4 w-full">
                Permite buscar, consultar y gestionar las transcodificaciones registradas en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible realizar búsquedas por <strong>prestador, domicilio, financiador y códigos de prestación</strong>, además de acceder a las opciones para <strong>agregar</strong> una nueva transcodificación o <strong>cargar un archivo</strong>.
           </p>   
                 
           
            <img class="mt-4" src="assets/images/guia/10-sistemas/sistemas-1.png" alt="Ingreso de Unexa">    
                  
        `,
    },
    
    {
        id: 'agregar-sistema',
        categoryId: 'sistemas',
        slug: 'agregar-sistema',
        title: 'Agregar sistema',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Agregar sistema</h2>

            <p class="mt-4 w-full">
                Permite registrar un nuevo software en Unexa y asociarle la información de contacto correspondiente.
            </p>
            <p class="mt-4 w-full">
                El proceso se realiza en dos pasos:
           </p>   
           <ol class="ml-8 mt-4 w-full ol-list">
                <li><strong>Información del software: </strong> Se ingresa el nombre del software que se desea registrar.</li>
                <li><strong>Información de contacto:</strong> Se completan los datos del contacto asociado al sistema, como medio de <strong>contacto, teléfono, nombre, tipo de contacto y observaciones</strong>.</li>
                
            </ol>
            <p class="mt-4 w-full">
                Una vez completados los datos requeridos en cada etapa, es posible finalizar el alta del sistema.
           </p>   
                 
           
            <img class="mt-4" src="assets/images/guia/10-sistemas/agregar-sistema-1.png" alt="Ingreso de Unexa">    
                  
        `,
    },
    {
        id: 'generar-token',
        categoryId: 'sistemas',
        slug: 'generar-token',
        title: 'Generar token',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Generar token</h2>

            <p class="mt-4 w-full">
                Permite generar un nuevo token para un sistema determinando.
            </p>          
           
            <img class="mt-4" src="assets/images/guia/10-sistemas/generar-token-1.png" alt="Ingreso de Unexa">    
                  
        `,
    },
    {
        id: 'editar-software',
        categoryId: 'sistemas',
        slug: 'editar-software',
        title: 'Editar software',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Editar software</h2>

            <p class="mt-4 w-full">
                Permite modificar la información del software registrado en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible actualizar el <strong>nombre</strong del software y continuar con la edición de la información asociada.
           </p>   
           
                 
           
            <img class="mt-4" src="assets/images/guia/10-sistemas/editar-software-1.png" alt="Ingreso de Unexa">    
                  
        `,
    },
    {
        id: 'asignar',
        categoryId: 'sistemas',
        slug: 'asignar',
        title: 'Asignar un contacto',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Asignar un contacto</h2>

            <p class="mt-4 w-full">
                Permite asociar un contacto al sistema seleccionado.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, se completan los datos del contacto, como <strong>medio de contacto, nombre, tipo de contacto y observaciones</strong>, antes de confirmar la asignación.
           </p>   
           
                 
           
            <img class="mt-4" src="assets/images/guia/10-sistemas/asignar-1.png" alt="Ingreso de Unexa">    
                  
        `,
    },
    {
        id: 'pruebas',
        categoryId: 'pruebas',
        slug: 'pruebas',
        title: 'Pruebas',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Pruebas</h2>

            <p class="mt-4 w-full">
                Permite validar flujos y generar requests o URLs internas en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible seleccionar el entorno o sistema sobre el que se realizará la prueba, completar los datos requeridos de la operación y ejecutar la consulta correspondiente.
           </p>   
           
                 
           
            <img class="mt-4" src="assets/images/guia/11-pruebas/pruebas-1.png" alt="Ingreso de Unexa">    
                  
        `,
    },
    {
        id: 'contactos',
        categoryId: 'contactos',
        slug: 'contactos',
        title: 'Contactos',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Contactos</h2>

            <p class="mt-4 w-full">
                Permite buscar, consultar y gestionar los contactos registrados en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible realizar búsquedas según un criterio definido y visualizar los resultados obtenidos para consultar la información asociada a cada contacto.
           </p>   
           
                 
           
            <img class="mt-4" src="assets/images/guia/12-contactos/contactos-1.png" alt="Ingreso de Unexa">    
                  
        `,
    },
    {
        id: 'buscar-contacto',
        categoryId: 'contactos',
        slug: 'buscar-contacto',
        title: 'Buscar contacto',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Buscar contacto</h2>

            <p class="mt-4 w-full">
                Para localizar un contacto:
            </p>
            <img class="mt-4" src="assets/images/guia/12-contactos/buscar-1.png" alt="Ingreso de Unexa">
            <p class="mt-4 w-full">
                Debe seleccionar un criterio de búsqueda, ingresar el dato correspondiente y presionar <strong>Buscar.</strong>
            </p>
            <img class="mt-4" src="assets/images/guia/12-contactos/buscar-2.png" alt="Ingreso de Unexa">
            <p class="mt-4 w-full">
                Una vez realizada la búsqueda, el sistema muestra los registros que coinciden con la información ingresada.
            </p>  
                  
        `,
    },
    {
        id: 'detalle-contacto',
        categoryId: 'contactos',
        slug: 'detalle-contacto',
        title: 'Detalles de contacto',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Detalles de contacto</h2>

            <p class="mt-4 w-full">
                Permite consultar la información principal del contacto seleccionado.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible visualizar sus datos básicos, como <strong>nombre, tipo, teléfono y observaciones</strong>, además de consultar las <strong>asignaciones</strong> de prestadores y <strong>lugares de atención</strong> asociadas al contacto.
            </p>
            <img class="mt-4" src="assets/images/guia/12-contactos/detalle-1.png" alt="Ingreso de Unexa"> 
                  
        `,
    },
    {
        id: 'editar-contacto',
        categoryId: 'contactos',
        slug: 'editar-contacto',
        title: 'Editar contacto',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Editar contacto</h2>

            <p class="mt-4 w-full">
                Permite consultar la información principal del contacto seleccionado.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible visualizar sus datos básicos, como <strong>nombre, tipo, teléfono y observaciones</strong>, además de consultar las <strong>asignaciones</strong> de prestadores y <strong>lugares de atención</strong> asociadas al contacto.
            </p>
            <img class="mt-4" src="assets/images/guia/12-contactos/editar-1.png" alt="Ingreso de Unexa"> 
                  
        `,
    },
    {
        id: 'usuarios',
        categoryId: 'usuarios',
        slug: 'usuarios',
        title: 'Usuarios',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Usuarios</h2>

            <p class="mt-4 w-full">
                Permite consultar y gestionar los usuarios registrados en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible visualizar el listado de usuarios, organizado alfabéticamente, y consultar la información principal de cada registro, como <strong>nombre, correo electrónico y rol</strong>.
            </p>
            <img class="mt-4" src="assets/images/guia/13-usuarios/usuarios-1.png" alt="Ingreso de Unexa"> 
                  
        `,
    },
    {
        id: 'nuevo',
        categoryId: 'usuarios',
        slug: 'nuevo',
        title: 'Nuevo usuario',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Nuevo usuario</h2>

            <p class="mt-4 w-full">
                Permite registrar un nuevo usuario en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, se completan los datos de <strong>identificación, contacto y horario</strong>, además de seleccionar el <strong>rol</strong> correspondiente antes de guardar el registro.
            </p>
            <img class="mt-4" src="assets/images/guia/13-usuarios/nuevo-1.png" alt="Ingreso de Unexa"> 
                  
        `,
    },
    {
        id: 'detalle',
        categoryId: 'usuarios',
        slug: 'detalle',
        title: 'Detalles del usuario',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Detalles del usuario</h2>

            <p class="mt-4 w-full">
               Permite consultar la información completa de un usuario registrado en Unexa.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible <strong>restablecer la contraseña, editar la información del usuario, consultar el historial de horarios especiales o registrar nuevos horarios</strong> según corresponda.
            </p>
            <img class="mt-4" src="assets/images/guia/13-usuarios/detalle-1.png" alt="Ingreso de Unexa"> 
                  
        `,
    },
    {
        id: 'restablecer',
        categoryId: 'usuarios',
        slug: 'restablecer',
        title: 'Restablecer contraseña',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Restablecer contraseña</h2>

            <p class="mt-4 w-full">
               Permite confirmar el restablecimiento de la contraseña del usuario seleccionado.
            </p>
          
            <img class="mt-4" src="assets/images/guia/13-usuarios/restablecer-1.png" alt="Ingreso de Unexa"> 
                  
        `,
    },
    {
        id: 'editar',
        categoryId: 'usuarios',
        slug: 'editar',
        title: 'Editar usuario',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Editar usuario</h2>

            <p class="mt-4 w-full">
               Permite modificar la información del usuario seleccionado en Unexa.
            </p>
            <p class="mt-4 w-full">
               Desde esta vista, es posible actualizar los datos de <strong>identificación, contacto, horario y rol</strong> asignado al usuario. 
            </p>
            <p class="mt-4 w-full">
               Además, se encuentran disponibles las acciones para <strong>guardar, cancelar o eliminar</strong> el registro.
            </p>
          
            <img class="mt-4" src="assets/images/guia/13-usuarios/editar-1.png" alt="Ingreso de Unexa"> 
                  
        `,
    },
    {
        id: 'historial',
        categoryId: 'usuarios',
        slug: 'historial',
        title: 'Historial de horarios especiales',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Historial de horarios especiales</h2>

            <p class="mt-4 w-full">
               Permite consultar los registros históricos de horarios especiales asociados al usuario seleccionado.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible filtrar los resultados por <strong>tipo y estado</strong>, y visualizar cada registro con su información principal, como fecha, horario y condición asociada, por ejemplo <strong>guardia, licencia o vacaciones</strong>.
            </p>
            
          
            <img class="mt-4" src="assets/images/guia/13-usuarios/historial-1.png" alt="Ingreso de Unexa"> 
                  
        `,
    },
    {
        id: 'agregar',
        categoryId: 'usuarios',
        slug: 'agregar',
        title: 'Agregar horario especial',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Agregar horario especial</h2>

            <p class="mt-4 w-full">
               Permite registrar un horario especial para el usuario seleccionado.
            </p>
            <p class="mt-4 w-full">
                Desde esta vista, es posible indicar el tipo de <strong>horario especial, la fecha y el rango horario</strong> correspondiente, definiendo la hora desde y hasta antes de guardar el registro.
            </p>
            
          
            <img class="mt-4" src="assets/images/guia/13-usuarios/agregar-1.png" alt="Ingreso de Unexa"> 
                  
        `,
    },
    {
        id: 'notificaciones',
        categoryId: 'notificaciones',
        slug: 'agregar',
        title: 'Notificaciones',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Notificaciones</h2>

            <p class="mt-4 w-full">
               Permite gestionar y buscar las notificaciones por titulo o descripción.
            </p>
          
            <img class="mt-4" src="assets/images/guia/14-notificaciones/notificaciones-1.png" alt="Ingreso de Unexa"> 
                  
        `,
    },
    {
        id: 'admin-iis',
        categoryId: 'admin-iis',
        slug: 'agregar',
        title: 'Administación de los IIS',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Administación de los IIS</h2>

            <p class="mt-4 w-full">
               Permite consultar y editar de manera dinámina los IIS.
            </p>
          
            <img class="mt-4" src="assets/images/guia/15-admin-iis/admin-1.png" alt="Ingreso de Unexa"> 
                  
        `,
    },
    {
        id: 'asociaciones',
        categoryId: 'asociaciones',
        slug: 'agregar',
        title: 'Asociaciones',
        subtitle: '',

        coverImage: 'assets/images/guia/01-que-es-unexa/1.png',

        content: `
            <h2 class="mt-4 w-full">Asociaciones</h2>

            <p class="mt-4 w-full">
               Permite la consulta y edición las actuales asociaciones, así como también la creación de las mismas.
            </p>
          
            <img class="mt-4" src="assets/images/guia/16-asociaciones/asociaciones-1.png" alt="Ingreso de Unexa"> 
                  
        `,
    },


];

// Since we only have one content for the demo, we will
// use the following mock-api on every request for every guide.
export const guideContent = `
<h2>Header Level 2</h2>

<p>
    <strong>Pellentesque habitant morbi tristique</strong> senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit
    amet, ante. Donec eu libero sit amet quam egestas semper. <em>Aenean ultricies mi vitae est.</em> Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper
    pharetra. Vestibulum erat wisi, condimentum sed, <code>commodo vitae</code>, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci,
    sagittis tempus lacus enim ac dui. <a href="#"
                                          class="link">Donec non enim</a>
    in turpis pulvinar facilisis. Ut felis.
</p>

<p>
    Orci varius natoque penatibus et magnis dis <em>parturient montes</em>, nascetur ridiculus mus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos
    himenaeos. Curabitur vitae sagittis odio. <mark>Suspendisse</mark> ullamcorper nunc non pellentesque laoreet. Curabitur eu tortor id quam pretium mattis. Proin ut quam velit.
</p>

<h3>Header Level 3</h3>

<img src="assets/images/pages/help-center/image-1.jpg">
<p class="text-secondary">
    <em>Nullam sagittis nulla in diam finibus, sed pharetra velit vestibulum. Suspendisse euismod in urna eu posuere.</em>
</p>

<h4>Header Level 4</h4>

<blockquote>
    <p>
        Blockquote. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus magna. Cras in mi at felis aliquet congue. Ut a est eget ligula molestie gravida. Curabitur
        massa. Donec eleifend, libero at sagittis mollis, tellus est malesuada tellus, at luctus turpis elit sit amet quam. Vivamus pretium ornare est.
    </p>
    <footer>
        Brian Hughes
    </footer>
</blockquote>

<ol>
    <li>Ordered list</li>
    <li>Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</li>
    <li>Aliquam tincidunt mauris eu risus.</li>
</ol>

<h5>Header Level 5</h5>

<ul>
    <li>Unordered list</li>
    <li>Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</li>
    <li>Aliquam tincidunt mauris eu risus.</li>
</ul>

<pre><code>#header h1 a {
    display: block;
    width: 300px;
    height: 80px;
}</code></pre>

<h6>Header Level 6</h6>

<dl>
    <dt>Definition list</dt>
    <dd>
        Quisque sit amet risus enim. Aliquam sit amet interdum justo, at ultricies sapien. Suspendisse et semper urna, in gravida eros. Quisque id nibh iaculis, euismod urna sed,
        egestas nisi. Donec eros metus, congue a imperdiet feugiat, sagittis nec ipsum. Quisque dapibus mollis felis non tristique.
    </dd>

    <dt>Definition list</dt>
    <dd>
        Ut auctor, metus sed dapibus tempus, urna diam auctor odio, in malesuada odio risus vitae nisi. Etiam blandit ante urna, vitae placerat massa mollis in. Duis nec urna ac
        purus semper dictum ut eget justo. Aenean non sagittis augue. Sed venenatis rhoncus enim eget ornare. Donec viverra sed felis at venenatis. Mauris aliquam fringilla nulla,
        sit amet congue felis dignissim at.
    </dd>
</dl>`;
